import { useNavigate } from 'react-router-dom';
import './Tools.scss';

const toolsSection = {
  title: 'Ferramentas Digitais',
  subtitle:
    'Aplicamos metodologias provadas como Jobs to Be Done, criada em Harvard, para impulsionar o crescimento do seu negócio digital. Descubra ferramentas práticas para inovar com foco no cliente.',
};

const toolsData = [
  {
    title: 'Questionário de Maturidade Digital',
    description:
      'Avalie o estado digital da sua empresa e identifique áreas de melhoria e crescimento.',
    buttonText: 'Iniciar Questionário',
    onClick: 'handleStartQuiz',
  },
  {
    title: 'Explore Jobs to Be Done',
    description:
      'Descubra como alinhar os seus produtos ou serviços às verdadeiras necessidades dos seus clientes.',
    buttonText: 'Explorar Ferramenta',
    onClick: 'handleStartJTBD',
  },
];

const Tools = () => {
  const navigate = useNavigate();

  const handleStartQuiz = () => {
    navigate('/ferramentas/maturidade-digital');
  };

  const handleStartJTBD = () => {
    navigate('/ferramentas/jobs-to-be-done');
  };

  const actionHandlers = {
    handleStartQuiz,
    handleStartJTBD,
  };

  return (
    <section className="tools section">
      <div className="wrapper wrapper--large">
        <h1 className="wrapper__title centered">
          {toolsSection.title}
        </h1>
        <h2 className="wrapper__subtitle h5 centered">
          {toolsSection.subtitle}
        </h2>

        <div className="row">
          {toolsData.map((tool, index) => (
            <div key={index} className="col card">
              <h3 className="card__title h4">{tool.title}</h3>
              <p className="card__description centered">{tool.description}</p>
              <button
                type="button"
                className="cta-filled"
                onClick={actionHandlers[tool.onClick]}
              >
                {tool.buttonText}
              </button>
            </div>
          ))}

          <div className="col">
            <img
              alt=""
              className="card__illustration-col"
              src="/images/toolspage/digital-tools.webp"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tools;